import React from 'react';
import {get} from 'lodash';

const linkExtractor = (text) => {
  if (text.includes('|| + ')) {
    return text.split('|| + ')
  } else {
    return ['', text]
  }
}

const YoutubePost = ({ post }) => {
  const [text, youtubeMeta] = linkExtractor(get(post, 'text'));
  const [youtubeText, youtubeLink] = youtubeMeta.split('\n');

  return (
    <React.Fragment>
      {text && text.trim().length > 0 &&
        <p>{text}</p>
      }

      <a
        className='Posts__item__right__middle__youtube'
        href={youtubeLink}
        target='_blank' rel='nofollow'
      >
        <h4>{youtubeText}</h4>
        <p>{youtubeLink}</p>
      </a>
    </React.Fragment>
  )
}

export default YoutubePost
